import {EdcUiFeature} from '../edc-ui-feature';

export const ENTERPRISE_EDITION_FEATURES: EdcUiFeature[] = [
  'logout-button',
  'connector-limits',
  'sovity-zammad-integration',
];
